document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const openBtn = document.querySelector('.main-navigation__toggle');
  const closeBtn = document.querySelector('.mega-menu__close');
  const mega = document.getElementById('kutia-mega-menu');
  const panelItems = document.querySelectorAll('.main-navigation__item.has-panel');

  const setMegaOpen = (open) => {
    body.classList.toggle('js-mega-open', open);
    openBtn?.setAttribute('aria-expanded', open ? 'true' : 'false');
    mega?.setAttribute('aria-hidden', open ? 'false' : 'true');
  };

  const closePanels = (except = null) => {
    panelItems.forEach((item) => {
      if (item === except) return;
      item.classList.remove('is-open');
      const btn = item.querySelector('.main-navigation__link');
      const panel = item.querySelector('.nav-panel');
      btn?.setAttribute('aria-expanded', 'false');
      panel?.setAttribute('aria-hidden', 'true');
    });
  };

  openBtn?.addEventListener('click', () => setMegaOpen(true));
  closeBtn?.addEventListener('click', () => setMegaOpen(false));

  document.addEventListener('click', (event) => {
    const insidePanel = event.target.closest('.main-navigation__item.has-panel');
    if (!insidePanel) {
      closePanels();
    }
  });

  panelItems.forEach((item) => {
    const btn = item.querySelector('button.main-navigation__link');
    const panel = item.querySelector('.nav-panel');
    if (!btn || !panel) return;

    btn.addEventListener('click', (event) => {
      event.preventDefault();
      const willOpen = !item.classList.contains('is-open');
      closePanels(willOpen ? item : null);
      item.classList.toggle('is-open', willOpen);
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      panel.setAttribute('aria-hidden', willOpen ? 'false' : 'true');
    });

    item.addEventListener('mouseenter', () => {
      panel.setAttribute('aria-hidden', 'false');
      btn.setAttribute('aria-expanded', 'true');
    });

    item.addEventListener('mouseleave', () => {
      if (item.classList.contains('is-open')) return;
      panel.setAttribute('aria-hidden', 'true');
      btn.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (body.classList.contains('js-mega-open')) {
      setMegaOpen(false);
      openBtn?.focus();
      return;
    }
    closePanels();
  });
});
